/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Usage_Never_Item_2Inputs */

const es_privacy_policy_usage_never_item_2 = /** @type {(inputs: Privacy_Policy_Usage_Never_Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vender sus datos a anunciantes o agentes de datos`)
};

const en_privacy_policy_usage_never_item_2 = /** @type {(inputs: Privacy_Policy_Usage_Never_Item_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selling your data to advertisers or data brokers`)
};

/**
* | output |
* | --- |
* | "Selling your data to advertisers or data brokers" |
*
* @param {Privacy_Policy_Usage_Never_Item_2Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_usage_never_item_2 = /** @type {((inputs?: Privacy_Policy_Usage_Never_Item_2Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Usage_Never_Item_2Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_usage_never_item_2(inputs)
	return en_privacy_policy_usage_never_item_2(inputs)
});
export { privacy_policy_usage_never_item_2 as "privacy_policy.usage.never_item_2" }